"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unitConversion = exports.unitCheck = exports.toBaseUnit = exports.parseNumberValue = exports.isValidNumber = void 0;
const exception_1 = require("./exception");
const unit_1 = require("./unit");
const value_1 = require("./value");
const isValidNumber = (input) => {
    const { length } = input;
    let start;
    let dotSeen = false;
    if (!length) {
        return false;
    }
    if (input[0] === "+" || input[0] === "-") {
        start = 1;
        if (length < 2) {
            return false;
        }
    }
    else {
        start = 0;
    }
    for (let i = start; i < length; ++i) {
        const c = input[i];
        if (c === ".") {
            if (dotSeen || i === start || i + 1 > length) {
                return false;
            }
            dotSeen = true;
        }
        else if (!/^[0-9]$/.test(c)) {
            return i > start && (0, unit_1.findUnitBySymbol)(input.substring(i)) != null;
        }
    }
    return true;
};
exports.isValidNumber = isValidNumber;
const parseNumberValue = (input) => {
    const { length } = input;
    let start;
    const end = input.length;
    let dotSeen = false;
    if (!length) {
        return (0, value_1.newNumberValue)(0);
    }
    if (input[0] === "+" || input[0] === "-") {
        start = 1;
    }
    else {
        start = 0;
    }
    for (let i = start; i < length; ++i) {
        const c = input[i];
        if (c === ".") {
            if (dotSeen || i === start || i + 1 > length) {
                throw new exception_1.SyntaxError("Unexpected `.', missing number.");
            }
            dotSeen = true;
        }
        else if (!/^[0-9]$/.test(c)) {
            const symbol = input.substring(i);
            const unit = (0, unit_1.findUnitBySymbol)(symbol);
            if (unit == null) {
                throw new exception_1.SyntaxError(`Unrecognized measurement unit: ${symbol}`);
            }
            return (0, value_1.newNumberValue)(input.substring(0, i), unit);
        }
    }
    return (0, value_1.newNumberValue)(input.substring(0, end));
};
exports.parseNumberValue = parseNumberValue;
const toBaseUnit = (number) => {
    const { unit, value } = number;
    if (unit && !(0, unit_1.isBaseUnit)(unit)) {
        return unit.multiplier > 0
            ? value.mul(unit.multiplier)
            : value.div(-unit.multiplier);
    }
    return value;
};
exports.toBaseUnit = toBaseUnit;
const unitCheck = (a, ...others) => {
    for (const b of others) {
        if (a.unit && b.unit) {
            if (a.unit.type !== b.unit.type) {
                throw new exception_1.UnitError(`Cannot compare ${a.unit.type.toLowerCase()} against ${b.unit.type.toLowerCase()}.`);
            }
        }
        else if (b.unit) {
            throw new exception_1.UnitError(`Cannot compare number without an unit against number which has ${b.unit.type.toLowerCase()} as measurement unit.`);
        }
    }
};
exports.unitCheck = unitCheck;
const unitConversion = (value, baseUnit) => {
    if (baseUnit != null) {
        for (const unit of (0, unit_1.getAllUnitsOf)(baseUnit.type)) {
            const { multiplier } = unit;
            if (multiplier > 0 && value.comparedTo(multiplier) >= 0) {
                return (0, value_1.newNumberValue)(value.div(multiplier), unit);
            }
        }
    }
    return (0, value_1.newNumberValue)(value, baseUnit);
};
exports.unitConversion = unitConversion;
